var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("i", { staticClass: "d-flex align-items-center small" }, [
    _vm._v("\n    modified\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }